<template>
    <div class="row">
        <div class="c-product__filters col-md-3 col-xl-2 pr-4">
            <div v-for="attribute in attributes">
            <h3 class="c-product__filters-title">{{ attribute.title }}</h3>
            <ul v-for="value in attribute.values" class="c-product__filters-list">
                <li v-if="value.enabled">
                    <input type="checkbox" :id="value.id" :value="value.id" v-model="activeFilters">{{ value.title }}
                </li>
               <!-- <li v-else>
                    <input type="checkbox" :id="value.id" :value="value.id" v-model="activeFilters" disabled><span v-bind:style="{ color: '#888'}">{{ value.title }}</span>
                </li>-->
            </ul>
            </div>
        </div>
        <div class="c-product__catalogue col-md-9 col-xl-10">
            <div class="row">

                <div v-for="product in activeContents" class="c-widget-products col-12 col-md-6 col-xl-3 text-center">

                    <a v-bind:href="product.url" class="c-widget-products__image" v-bind:style="{ backgroundImage: 'url(' + product.image + ')' }"></a>

                    <a v-bind:href="product.url" class="c-widget-products__title">
                        {{ product.name }}
                    </a>
                    <div href="#" class="c-widget-products__model">
                        {{ product.model }}
                    </div>
                    <div :class="{'price-tachado': product.price_with_discount !== product.price}" class="c-widget-products__price">
                        ${{ product.price }}
                    </div>
                    <div v-if="product.price_with_discount !== product.price" href="#" class="c-widget-products__price">
                        ${{ product.price_with_discount }}
                    </div>
                    <a v-bind:href="product.url" class="btn o-custom-button-gradient" >
                        {{ 'messages.view_more' | trans }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['categoryId'],
        created() {
            this.getAttributes();
            this.getProducts();
        },
        data() {
            return {
                activeFilters: [],
                attributes: [],
                products: []
            }
        },
        computed: {
            activeContents(){
                let filters = this.activeFilters;
                if(filters.length){
                    return this.products.filter((product) => {
                        return this.compareArrays(product.values, filters);
                    });
                }
                return this.products;
            }
        },

        methods: {
            compareArrays: function (values, filters) {
                var response = false;
                values.forEach(function(element){
                    if(filters.includes(element.id)){
                        response = true;
                    }
                });
                return response;
            },
            getAttributes: function () {
                axios
                    .get(route('ajax.getAttributes', this.categoryId))
                    .then(response => {
                        this.attributes = response.data;
                    });
            },
            getProducts: function (search = null) {
                axios
                    .get(route('ajax.getProducts', this.categoryId))
                    .then(response => {
                        this.products = response.data;
                    });
            },
        }
    }
</script>
